import { render } from "./Mb020.vue?vue&type=template&id=4e6100be&scoped=true"
import script from "./Mb020.vue?vue&type=script&lang=js"
export * from "./Mb020.vue?vue&type=script&lang=js"

import "./Mb020.vue?vue&type=style&index=0&id=4e6100be&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e6100be"]])

export default __exports__